/* 🤖 this file was generated by svg-to-ts */
export const svgCheck: {
    name: "check";
    data: string;
} = {
    name: "check",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__check" viewBox="0 0 24 24"><path id="ng__path-check" fill="none" stroke-linecap="round" d="M0 2.56294L3.00879 5.1428L7 0" transform="translate(9 10)"/></symbol></svg>`,
};
